import React, { useState } from "react";
import { Button, Menu, Popover } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { CHART_SETTINGS, TIMESPAN_SETTINGS, TREND_SETTINGS, YAXIS_SETTINGS } from "./constants";
import { usePopularChartContext } from "../../contexts/popularchartcontext";

const ChartSettings = ({ enableTrend, lineLabel }) => {
  const { setTimespanSetting, setTrendSetting, setYAxisSetting } = usePopularChartContext();
  const [selectedKeys, setSelectedKeys] = useState([
    TIMESPAN_SETTINGS.DAY,
    YAXIS_SETTINGS.ZERO,
    TREND_SETTINGS.LINE_AND_TREND,
  ]);

  const handleClick = (event) => {
    const [option, category] = event.keyPath;
    const actionObject = {
      [CHART_SETTINGS.TIMESPAN]: {
        settings: TIMESPAN_SETTINGS,
        contextSetter: setTimespanSetting,
      },
      [CHART_SETTINGS.YAXIS]: {
        settings: YAXIS_SETTINGS,
        contextSetter: setYAxisSetting,
      },
      [CHART_SETTINGS.TREND]: {
        settings: TREND_SETTINGS,
        contextSetter: setTrendSetting,
      },
    };
    actionObject[category].contextSetter(option);
    const newKeys = selectedKeys.filter((key) => !Object.values(actionObject[category].settings).includes(key));
    setSelectedKeys([...newKeys, option]);
  };

  return (
    <Popover
      placement="bottomRight"
      overlayClassName="mm-chart-options-popover"
      content={
        <Menu
          multiple
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={[CHART_SETTINGS.TIMESPAN, CHART_SETTINGS.TREND, CHART_SETTINGS.YAXIS]}
          onClick={handleClick}
        >
          <Menu.SubMenu key={CHART_SETTINGS.TIMESPAN} title="Results By Timespan">
            <Menu.Item key={TIMESPAN_SETTINGS.DAY}>Results By Day</Menu.Item>
            <Menu.Item key={TIMESPAN_SETTINGS.WEEK}>Results By Week</Menu.Item>
            <Menu.Item key={TIMESPAN_SETTINGS.MONTH}>Results By Month</Menu.Item>
          </Menu.SubMenu>
          {enableTrend ? (
            <Menu.SubMenu key={CHART_SETTINGS.TREND} title="Trend Line">
              <Menu.Item key={TREND_SETTINGS.LINE_ONLY}>Show {lineLabel} Only</Menu.Item>
              <Menu.Item key={TREND_SETTINGS.TREND_ONLY}>Show Trend Only</Menu.Item>
              <Menu.Item key={TREND_SETTINGS.LINE_AND_TREND}>Show Trend and {lineLabel}</Menu.Item>
            </Menu.SubMenu>
          ) : null}
          <Menu.SubMenu key={CHART_SETTINGS.YAXIS} title="Y Axis">
            <Menu.Item key={YAXIS_SETTINGS.LOW_SALE}>Start Graph at Low Sale</Menu.Item>
            <Menu.Item key={YAXIS_SETTINGS.ZERO}>Start Graph at $0</Menu.Item>
          </Menu.SubMenu>
        </Menu>
      }
      trigger="click"
    >
      <Button type="ghost" icon={<SettingOutlined />} />
    </Popover>
  );
};

export default ChartSettings;
